import script from "./Org_Items.vue?vue&type=script&setup=true&lang=ts"
export * from "./Org_Items.vue?vue&type=script&setup=true&lang=ts"

import "./Org_Items.vue?vue&type=style&index=0&id=54f32a25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54f32a25"]])

export default __exports__